export const LOADS_SORTINGS = [
  {
    label: 'LOADED_ON',
    value: 'createdOn',
    isDefault: true,
  },
];

export const LOADS_FILTERS = [
  {
    keyName: 'completedOn',
    operator: 'lt',
  },
  { keyName: 'isSuccessful', operator: 'eq' },
  { keyName: 'sectionName' },
];

export const STATUSES_OPTIONS = [
  {
    value: 'completed',
    label: 'COMPLETED',
  },
  {
    value: 'error',
    label: 'ERROR',
  },
  {
    value: 'processing',
    label: 'PROCESSING',
  },
];
